import css from "./something-went-wrong.module.scss";
import Seo from "../../components/seo/Seo";

const SomethingWentWrong = () => {

    function typeOfError() {
        const urlParams = new URLSearchParams(window.location.search);
        const errorType = urlParams.get('error');
        if (errorType === '404') {
            return 'Pagina niet gevonden';
        } else if (errorType === '500') {
            return 'Interne serverfout';
        } else {
            return 'Onbekende fout';
        }
    }
    return (
        <div className={css.container}>
            <Seo
                title="Er is iets misgegaan | BolleNoord 't Zand B.V."
                description="Er is een fout opgetreden. Ga terug naar de homepage of neem contact met ons op als het probleem blijft bestaan."
                path="/fout"
                robots="noindex, nofollow"
            />
            <h1>Er is iets fout gegaan!</h1>
            <p>{typeOfError()}</p>
        </div>
    );
}

export default SomethingWentWrong;